import React, { useState } from 'react';
import Account from './account/Account';
import { AddFundSC } from './MockBillingInfo.style';
import ServicesByServerpoint from './services-by-severpoint';
import Invoices from './invoice/Invoices';
import { mockInvoiceData, mockStoredCreditCards, mockUserUiDetails } from '../constant';
import Mockup from '../Mockup';

const MockBillingInfo = () => {
  const [modalActive, setModalActive] = useState(false);
  const userUI = mockUserUiDetails;
  const handleShowModal = () => {
    setModalActive(true);
  };
  const handleCloseModal = () => {
    setModalActive(false);
    document.getElementById('add_funds_vs_reserved').classList.remove('focused-payment');
  };

  return (
    <Mockup>
      <AddFundSC>
        {modalActive && <div onClick={() => handleCloseModal()} className="overlay" />}
        <Account storedCreditCards={mockStoredCreditCards} />
        <ServicesByServerpoint modalActive={modalActive} handleCloseModal={handleCloseModal} />
        {userUI?.show_invoice_list == 1 && <Invoices invoiceData={mockInvoiceData} onShowModal={handleShowModal} />}
      </AddFundSC>
    </Mockup>
  );
};
export default MockBillingInfo;
